import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Duty Roster Service (Refactored to use EmployeeRosterDetail)
 */
const dutyRosterService = {
  /**
   * Get total schedule data (all employees with rosters)
   * @param {string} date - Optional date string (YYYY-MM-DD)
   */
  getDutyRoster: async (date, viewType = 'weekly') => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/duty-roster/schedule`, {
        params: { date, viewType }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching schedule:', error);
      throw error;
    }
  },

  /**
   * Options for the "Manage teams" modal: { managers, staff }.
   * staff rows include their current team (group_id / group_name).
   */
  getTeamOptions: async () => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.get(`/${routePath}/duty-roster/team-options`);
      return response.data;
    } catch (error) {
      console.error('Error fetching team options:', error);
      throw error;
    }
  },

  /**
   * Move staff between teams (Manage teams).
   * payload: { assignments: [{ user_id, group_id|null }] }
   */
  reassignMembers: async (payload) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.put(`/${routePath}/duty-roster/members`, payload);
      return response.data;
    } catch (error) {
      console.error('Error reassigning members:', error);
      throw error;
    }
  },

  /**
   * Edit a team's name and manager.
   * payload: { name, manager_id|null }
   */
  renameTeam: async (teamId, payload) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.put(`/${routePath}/duty-roster/teams/${teamId}`, payload);
      return response.data;
    } catch (error) {
      console.error('Error updating team:', error);
      throw error;
    }
  },

  /** Delete a team (immediately) — its staff move to Unassigned. */
  deleteTeam: async (teamId) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.delete(`/${routePath}/duty-roster/teams/${teamId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting team:', error);
      throw error;
    }
  },

  /**
   * Cover: schedule a carer to work a day they'd otherwise be off / on holiday.
   * payload: { employee_id, date 'YYYY-MM-DD', start_time 'HH:MM', end_time 'HH:MM', note }
   */
  createCover: async (payload) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(`/${routePath}/duty-roster/covers`, payload);
      return response.data;
    } catch (error) {
      console.error('Error creating cover:', error);
      throw error;
    }
  },

  /**
   * Assign a recurring shift (Updates EmployeeRosterDetail)
   */
  assignShift: async (rosterData) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(`/${routePath}/duty-roster/assign`, rosterData);
      return response.data;
    } catch (error) {
      console.error('Error assigning shift:', error);
      throw error;
    }
  },

  /**
   * Remove a day from an employee's recurring roster
   */
  removeAssignment: async (userId, dayName) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.delete(`/${routePath}/duty-roster/assignment`, {
        params: { userId, dayName }
      });
      return response.data;
    } catch (error) {
      console.error('Error removing assignment:', error);
      throw error;
    }
  },

  /**
   * Record / approve manager-entered shift hours (Review flow).
   * payload: { employeeId, date (YYYY-MM-DD), clockIn 'HH:MM', clockOut 'HH:MM', note }
   */
  recordManualShift: async (payload) => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(`/${routePath}/duty-roster/manual-shift`, payload);
      return response.data;
    } catch (error) {
      console.error('Error recording manual shift:', error);
      throw error;
    }
  },

  /**
   * Publish schedule (Mock)
   */
  publishSchedule: async () => {
    try {
      const routePath = getManagerRoutePath();
      const response = await axiosInstance.post(`/${routePath}/duty-roster/publish`);
      return response.data;
    } catch (error) {
      console.error('Error publishing schedule:', error);
      throw error;
    }
  }
};

export default dutyRosterService;
